export default "__VITE_ASSET__sXNeo2nf__"